import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
export var useLocalStorage = function useLocalStorage(key, defaultValue) {
  // try {
  var stored = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
  var initial = stored ? JSON.parse(stored) : defaultValue;
  var _useState = useState(initial),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  // } catch(error) {
  // console.error(error)
  // }
  return [value, setValue];
};
export var setLocalStorage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window !== 'undefined')) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return localStorage.setItem(key, JSON.stringify(value));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function setLocalStorage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getLocalStorage = function getLocalStorage(key) {
  if (typeof window !== 'undefined') {
    var stored = localStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
  }
  return null;
};